import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CartItemsTotal } from "src/app/models/cart-items-total.model";
import { CartItems } from "src/app/models/cart-items.model";
import { CartItemsRequest } from "src/app/models/requests/cart-items-request.model";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root'
  })
  export class PaymentService extends BaseService {
  
    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, 'employees/[employee-id]/payment');
    }

    getDefaultCard() {
      return this.http.get<CartItemsTotal>(`${this.apiUrl}/card`);
    }

  }